import { BrowserRouter, useLocation } from 'react-router-dom';
import Cursor from './components/Cursor';
import SmoothScroll from './components/SmoothScroll';
import Home from './pages/Home';
import BlogPostOverlay from './components/BlogPostOverlay';
import './App.css';

function AppContent() {
  const location = useLocation();
  const blogMatch = location.pathname.match(/^\/blog\/([^/]+)/);
  const slug = blogMatch ? blogMatch[1] : null;

  return (
    <>
      <SmoothScroll articleOpen={!!slug} />
      <Cursor />
      <Home />
      {slug && <BlogPostOverlay key={slug} slug={slug} />}
    </>
  );
}

function App() {
  return (
    <BrowserRouter>
      <AppContent />
    </BrowserRouter>
  );
}

export default App;
